import { FC } from "react";
import { Image } from "@/components/Image/Image";

interface Props {
  image?: PreviewAsset;
}

export const BannerImage: FC<Props> = ({ image }) => {
  return image?.fields?.file?.details && image.fields.file.url ? (
    <Image
      key={image.fields.file.url}
      src={"https:" + image.fields.file.url}
      alt={image.fields.description ?? ""}
      width={image.fields.file.details.image?.width}
      height={image.fields.file.details.image?.height}
      className="h-[192px] w-full rounded-[12px] border border-solid border-gray-pale bg-white object-cover md:h-[400px] md:rounded-[4px]"
    />
  ) : (
    <Image
      src={"/images/kdotdev/banner.png"}
      alt={"Blog banner image"}
      width={500}
      height={500}
      className="h-[192px] w-full rounded-[12px] border border-solid border-gray-pale bg-white object-contain md:h-[400px] md:rounded-[4px]"
    />
  );
};
